// start:ng42.barrel
export * from './user-reservation-check.component';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/user-reservation-check/index.ts